import React from 'react';

import * as T from './interfaces';
import * as S from './styles';

export const ModalMobile: React.FC<T.IModalMobileProps> = ({
  children,
  onClose,
  ref,
  ...rest
}) => (
  <S.Wrapper ref={ref} {...rest} onDismiss={onClose}>
    {children}
  </S.Wrapper>
);
